export default "__VITE_ASSET__JR2O2KdC__"